import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP = "https://wa.me/966561653933";
export const TELEGRAM = "https://t.me/Research_Network";
export const ADMIN_PATH = "/rn-control-7711";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export function whatsappLink(text) {
  return `${WHATSAPP}?text=${encodeURIComponent(text)}`;
}
